import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading1 } from '@silvertours/front-legacy-shared';

type StageContentContainerProps = {
  isAffiliate?: boolean;
  isMinimal?: boolean;
  isErrorPage?: boolean;
  isStageVisibility?: boolean;
};

const StageWrapper = styled.div<StageContentContainerProps>`
  position: relative;

  ${({ theme }) => theme.mq('sm')} {
    min-height: ${({ isMinimal, isErrorPage }) =>
      (isMinimal && 'auto') || (isErrorPage && 'auto') || '438px'};
    ${({ isErrorPage }) =>
      isErrorPage &&
      css`
        margin-bottom: -3rem;
        z-index: 1;
      `}
  }
`;

const StageContentContainer = styled.div<StageContentContainerProps>`
  width: 100%;
  padding: 0;

  ${({ isAffiliate }) =>
    isAffiliate &&
    css`
      display: flex;
      height: 100vh;
      align-items: flex-start;
      justify-content: center;
    `}

  ${({ theme }) => theme.mq('sm')} {
    margin: 0 auto;
    background-color: transparent;
  }

  /* FIXME: This block causes layout issues with larger WidgetSearch, new type of StageContentContainer? */
  ${({ theme }) => theme.mq('lg')} {
    display: flex;
    height: ${({ isMinimal, isErrorPage }) =>
      (isMinimal && '10.375rem') ||
      (isErrorPage && '18.375rem') ||
      '29.375rem'};
    align-items: ${({ isStageVisibility }) =>
      isStageVisibility ? 'flex-end' : 'center'};

    ${({ isErrorPage }) =>
      isErrorPage &&
      css`
        margin-bottom: -3rem;
        z-index: 1;
        position: relative;
      `}
  }
`;

const WizardSearchWrapper = styled.div`
  margin-left: -1rem;
  margin-right: -1rem;

  ${({ theme }) => theme.mq('sm')} {
    display: none;
  }
`;

const StageLink = styled.a`
  display: none;

  ${({ theme }) => theme.mq('sm')} {
    display: block;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-height: 29.375rem;
    width: 100vw;
    text-indent: -100em;
  }
`;

const BadgesContainer = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 1;
  display: flex;
  place-items: flex-end;
  gap: 1rem;
  flex-direction: column;
`;

const TrustElement = styled.div`
  display: inline-flex;
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.radius.xs};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
`;

const StyledH1 = styled(Heading1)`
  margin: 0;
  padding: 1rem;
  font-size: 1.375rem;
  line-height: 1.2;
  text-align: center;
`;

export {
  BadgesContainer,
  StageContentContainer,
  StageLink,
  StageWrapper,
  TrustElement,
  StyledH1,
  WizardSearchWrapper,
};
